import React, { useState, useCallback } from 'react'
import { TextField } from 'components/input/TextField/TextField'

export const TextFieldWithLock = React.memo(
  ({
    optionName,
    optionValue,
    optionLabel,
    optionPlaceholder,
    handleOptionInfoChange,
    widthValue = '100%',
    maxLength,
    minLength,
    required = false,
    disabled = false,
    readOnly = false,
    error,
    type,
    lengthCount = maxLength !== undefined,
    validationOnTouch = false,
  }: {
    optionName: any
    optionValue: any
    optionLabel?: string
    optionPlaceholder?: string
    handleOptionInfoChange: any
    widthValue?: string
    maxLength?: number
    minLength?: number
    required?: boolean
    disabled?: boolean
    readOnly?: boolean
    error?: any
    type?: any
    lengthCount?: boolean
    validationOnTouch?: boolean
  }) => {
    const [touched, setTouched] = useState(false)

    const handleChange = useCallback(
      (value: any) => {
        handleOptionInfoChange(optionName, value)
      },
      [handleOptionInfoChange, optionName]
    )

    const handleFocus = useCallback(() => {
      if (!touched) setTouched(true)
    }, [touched])

    const resolvedError = validationOnTouch ? (touched ? error : undefined) : error

    return (
      <TextField
        type={type}
        size="large"
        label={optionLabel}
        required={required}
        value={optionValue ?? ''}
        handleValue={handleChange}
        onFocus={handleFocus}
        width={widthValue}
        placeholder={optionPlaceholder}
        disabled={disabled}
        readOnly={readOnly}
        icon={readOnly ? 'Lock01' : undefined}
        maxLength={maxLength}
        minLength={minLength}
        lengthCount={lengthCount}
        error={resolvedError}
      />
    )
  }
)
